export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-21.ce94801d.jpg";